module.exports = __webpack_public_path__ + "static/media/craft-10.8eb4aa94.svg";